<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { t } from '../../lib/i18n';
  
  export let show: boolean = false;
  export let title: string = t('Confirm Delete');
  export let message: string = t('Are you sure you want to delete this item? This action cannot be undone.');
  export let confirmText: string = t('Delete');
  export let cancelText: string = t('Cancel');
  export let loading: boolean = false;
  
  const dispatch = createEventDispatcher();
  
  function confirm() {
    dispatch('confirm');
  }
  
  function cancel() {
    show = false;
    dispatch('cancel');
  }
</script>

{#if show}
  <div class="modal d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5);">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{title}</h5>
          <button type="button" class="btn-close" on:click={cancel}></button>
        </div>
        <div class="modal-body">
          <p>{message}</p>
        </div>
        <div class="modal-footer">
          <button 
            type="button" 
            class="btn btn-secondary" 
            on:click={cancel}
            disabled={loading}
          >
            {cancelText}
          </button>
          <button 
            type="button" 
            class="btn btn-danger" 
            on:click={confirm}
            disabled={loading}
          >
            {loading ? t('Processing...') : confirmText}
          </button>
        </div>
      </div>
    </div>
  </div>
{/if}